import { css } from '@emotion/react';

export const buttonStyles = (theme) => css`
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    margin-bottom: 1rem;
    width: 100%;
  }
`;
